module.exports = {
  issueDate: '2026-10-01',
  validFrom: '2026-10-01',
  expiresAt: '2026-11-01',

  shelfEdit: null,
  booksHavingAMoment: null,

  backInSpotlight: {
    books: [
      {
        title: 'The Housemaid',
        author: 'Freida McFadden',
        category: 'from-page-to-screen',
        isbn: '9781538742570',
        editorialKey: 'housemaid',
        reasonLabel: 'Screen Buzz',
        note: 'Screen-adaptation buzz puts this twisty thriller back on the reading list.',
      },
      {
        title: 'Project Hail Mary',
        author: 'Andy Weir',
        category: 'from-page-to-screen',
        isbn: '9780593135204',
        editorialKey: 'project-hail-mary',
        reasonLabel: 'Page to Screen',
        note: 'Its big-screen story is a reason to revisit this inventive space adventure.',
      },
      {
        title: 'The Hunger Games',
        author: 'Suzanne Collins',
        category: 'having-a-moment',
        isbn: '9780439023481',
        editorialKey: 'hunger-games',
        reasonLabel: 'Back to Panem',
        note: 'New stories from Panem invite a return to the book that started it all.',
      },
      {
        title: 'The Seven Husbands of Evelyn Hugo',
        author: 'Taylor Jenkins Reid',
        category: 'having-a-moment',
        isbn: '9781501139239',
        editorialKey: 'evelyn-hugo',
        reasonLabel: 'Reader Favourite',
        note: 'A book-club favourite that keeps conversations about fame and love going.',
      },
      {
        title: 'Wuthering Heights',
        author: 'Emily Brontë',
        category: 'second-chapter',
        isbn: '9780141439556',
        editorialKey: 'wuthering-heights',
        reasonLabel: 'Classic Rediscovered',
        note: 'Fresh readings keep this stormy tale of love and obsession in the conversation.',
      },
      {
        title: 'The Devil Wears Prada',
        author: 'Lauren Weisberger',
        category: 'second-chapter',
        isbn: '9780767914765',
        editorialKey: 'devil-wears-prada',
        reasonLabel: 'Pop-Culture Comeback',
        note: 'Renewed screen interest brings this sharp fashion-world satire back into focus.',
      },
    ],
  },

  newReleases: [
    {
      title: 'Dead Beat',
      author: 'Leigh Bardugo',
      isbn: '9781250884312',
      releaseDate: '2026-09-15',
      note: 'A new novel from Leigh Bardugo.',
      coverUrl: 'https://images.penguinrandomhouse.com/cover/9781250884312',
      releaseDateVerified: false,
      legacySource: {
        name: 'Leigh Bardugo',
        url: 'https://www.leighbardugo.com/book/dead-beat/',
      },
    },
    {
      title: 'The Disappearers',
      author: 'Marlon James',
      isbn: '9780593717202',
      releaseDate: '2026-09-08',
      note: 'A new novel from the author of the Dark Star trilogy.',
      coverUrl: 'https://covers.openlibrary.org/b/isbn/9780593717202-L.jpg?default=false',
      releaseDateVerified: false,
      legacySource: null,
    },
    {
      title: 'The Pirate Queen',
      author: 'Ariel Lawhon',
      isbn: '9780385550345',
      releaseDate: '2026-09-08',
      note: 'A historical adventure from the author of The Frozen River.',
      coverUrl: 'https://images.penguinrandomhouse.com/cover/9780385550345',
      releaseDateVerified: false,
      legacySource: {
        name: 'Penguin Random House',
        url: 'https://images.penguinrandomhouse.com/cover/9780385550345',
      },
    },
    {
      title: 'The House of Gardenias',
      author: 'Isabel Cañas',
      isbn: '9780593620410',
      releaseDate: '2026-09-29',
      note: 'A lush gothic fantasy with a haunted estate and a dangerous new power.',
      coverUrl: 'https://images.penguinrandomhouse.com/cover/9780593620410',
      releaseDateVerified: false,
      legacySource: {
        name: 'Dutton Books / Penguin Random House',
        url: 'https://images.penguinrandomhouse.com/cover/9780593620410',
      },
    },
    {
      title: 'Hollywood, Ending',
      author: 'John Green',
      isbn: '9780525426073',
      releaseDate: '2026-09-22',
      note: 'A new novel from the author of The Anthropocene Reviewed.',
      coverUrl: 'https://images.penguinrandomhouse.com/cover/9780525426073',
      releaseDateVerified: false,
      legacySource: {
        name: 'Dutton Books / Penguin Random House',
        url: 'https://images.penguinrandomhouse.com/cover/9780525426073',
      },
    },
    {
      title: 'Hollow Bones',
      author: 'Jodi Picoult',
      isbn: '9780593726259',
      releaseDate: '2026-09-15',
      note: 'A new novel from Jodi Picoult.',
      coverUrl: 'https://images.penguinrandomhouse.com/cover/9780593726259',
      releaseDateVerified: false,
      legacySource: {
        name: 'Ballantine Books / Penguin Random House',
        url: 'https://images.penguinrandomhouse.com/cover/9780593726259',
      },
    },
    {
      title: 'Free Falling',
      author: 'Lyla Sage',
      isbn: '9780593977798',
      releaseDate: '2026-09-22',
      note: 'A new Sweetwater Peak romance from Lyla Sage.',
      coverUrl: 'https://images.penguinrandomhouse.com/cover/9780593977798',
      releaseDateVerified: false,
      legacySource: {
        name: 'Dial Press Trade Paperback / Penguin Random House',
        url: 'https://images.penguinrandomhouse.com/cover/9780593977798',
      },
    },
  ],

  authorSpotlight: null,
  closerToHome: null,
  comingSoon: [],

  archiveForReview: {
    sourceFile: 'src/containers/TrendingPage/trending/2026-09.json',
    sourceUpdatedAt: '2026-09-03',
    message:
      'These archived sections had no validity dates. Review their copy and assign fresh dates before moving them into active sections.',
    shelfEdit: {
      title: 'Books having a moment…again.',
      description:
        'Backlist favourites, rediscovered gems, adaptations, and books readers can’t stop talking about all over again.',
      books: [
        {
          title: 'The Love Hypothesis',
          author: 'Ali Hazelwood',
          isbn: '9780593336823',
          note: 'Adaptation coming soon',
          coverUrl: '/static/trending/love-hypothesis.jpg',
        },
        {
          title: 'The Book of Magic',
          author: 'Alice Hoffman',
          isbn: '9781982168094',
          note: 'Practical Magic season',
          coverUrl: '/static/trending/book-of-magic.jpg',
        },
        {
          title: 'Sunrise on the Reaping',
          author: 'Suzanne Collins',
          isbn: '9781546171461',
          note: 'Back to Panem',
          coverUrl: '/static/trending/sunrise-on-the-reaping.jpg',
        },
        {
          title: 'Goodbye, Ramona',
          author: 'Montserrat Roig',
          isbn: '9788411072262',
          note: 'Finding new readers',
          coverUrl: '/static/trending/goodbye-ramona.jpg',
        },
      ],
    },
    closerToHome: [
      {
        title: 'Station Eleven',
        author: 'Emily St. John Mandel',
        isbn: '9780804172448',
        note: "A Canadian novelist's enduring speculative classic.",
        coverUrl: 'https://covers.openlibrary.org/b/isbn/9780804172448-L.jpg?default=false',
      },
      {
        title: 'The Immortalists',
        author: 'Chloe Benjamin',
        isbn: '9780735213180',
        note: 'A thoughtful companion read from a Canadian-published author.',
        coverUrl: 'https://covers.openlibrary.org/b/isbn/9780735213180-L.jpg?default=false',
      },
      {
        title: 'The Frozen River',
        author: 'Ariel Lawhon',
        isbn: '9780593793251',
        note: 'A recent historical-fiction favourite with strong Canadian availability.',
        coverUrl: 'https://covers.openlibrary.org/b/isbn/9780593793251-L.jpg?default=false',
      },
      {
        title: 'The Marrow Thieves',
        author: 'Cherie Dimaline',
        isbn: '9781770864863',
        note: 'A powerful dystopian novel from the Georgian Bay Metis author.',
        coverUrl: 'https://images.penguinrandomhouse.com/cover/9781770864863',
      },
    ],
    authorSpotlight: {
      author: 'Emily St. John Mandel',
      intro:
        'A Canadian author whose novels move between intimate human stories and the wide horizon of speculative fiction.',
      whyNow:
        'Exit Party makes this a good month to revisit the books that established her distinctive, atmospheric voice.',
      ctaLabel: 'Explore their books',
      ctaUrl: 'https://www.emilymandel.com/',
      books: [
        {
          title: 'Station Eleven',
          author: 'Emily St. John Mandel',
          isbn: '9780804172448',
          coverUrl: 'https://covers.openlibrary.org/b/isbn/9780804172448-L.jpg?default=false',
        },
        {
          title: 'Sea of Tranquility',
          author: 'Emily St. John Mandel',
          isbn: '9780593556597',
          coverUrl: 'https://covers.openlibrary.org/b/isbn/9780593556597-L.jpg?default=false',
        },
        {
          title: 'The Glass Hotel',
          author: 'Emily St. John Mandel',
          isbn: '9780525521143',
          coverUrl: 'https://covers.openlibrary.org/b/isbn/9780525521143-L.jpg?default=false',
        },
      ],
    },
    excludedReleaseTitles: ['The Knave and the Moon', 'Under Story', 'Blacktail'],
  },
};
